import { Link } from "react-router-dom";
import { BookOpen, HelpCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import KnowledgeDirectory from "@/components/KnowledgeDirectory";
import { Button } from "@/components/ui/button";
import { faqSections } from "@/content/helpContent";

export default function Faq() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="page-shell py-10 md:py-14">
        <header className="border-b border-border pb-8">
          <div className="flex items-center gap-2 text-primary">
            <HelpCircle className="h-5 w-5" />
            <p className="text-xs font-black uppercase tracking-[0.25em]">Help centre</p>
          </div>
          <div className="mt-3 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="font-display text-3xl font-black md:text-5xl">Frequently asked questions</h1>
              <p className="mt-3 max-w-2xl text-sm leading-6 text-muted-foreground md:text-base">
                Clear answers about accounts, discovering events, buying tickets and venue entry.
              </p>
            </div>
            <Button asChild variant="outline" className="w-fit rounded-full">
              <Link to="/organiser-guide"><BookOpen className="mr-2 h-4 w-4" />Organiser guide</Link>
            </Button>
          </div>
        </header>

        <section className="py-8">
          <KnowledgeDirectory sections={faqSections} placeholder="Search questions, tickets, refunds or entry" />
        </section>
      </main>
    </div>
  );
}
